import { Handshake, TrendingUp, Users, Package, ArrowRight } from "lucide-react";

const benefits = [
  { icon: Package, title: "Pilihan Produk untuk Berbagai Kebutuhan", desc: "Material dan produk pendukung untuk pasar profesional serta kebutuhan proyek." },
  { icon: Users, title: "Dukungan Konsultasi Produk", desc: "Tim kami membantu Anda memilih spesifikasi tepat." },
  { icon: TrendingUp, title: "Pembelian Jumlah Besar", desc: "Skema harga khusus untuk kebutuhan proyek besar." },
  { icon: Handshake, title: "Kerja Sama Jangka Panjang", desc: "Kemitraan berkelanjutan untuk pertumbuhan bersama." },
];

export const Partnership = () => {
  return (
    <section id="kemitraan" data-testid="partnership-section" className="py-16 lg:py-20 bg-[#0a0a0a] text-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute -top-40 left-1/4 w-[500px] h-[500px] rounded-full bg-[#e60012]/10 blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-white/5 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="lg:col-span-6 min-w-0">
            <div className="tag-uppercase text-[#e60012] mb-4">Peluang Kemitraan</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-tight">
              Buka Peluang Kemitraan Bersama <span className="text-[#e60012]">PT. Animax Putra Lancar</span>
            </h2>
            <p className="mt-5 text-white/70 text-base leading-relaxed">
              Kami membuka peluang kerja sama untuk mitra usaha, toko material, kontraktor, dan
              mitra proyek di berbagai wilayah Indonesia untuk seluruh lini produk yang tersedia.
            </p>

            <a
              href="/kontak/#kontak"
              data-testid="partnership-cta"
              className="mt-7 group inline-flex items-center justify-center gap-2 px-6 sm:px-7 py-3.5 rounded-full bg-gradient-to-br from-[#e60012] to-[#ff6873] text-white ring-1 ring-white/25 font-medium text-sm hover:brightness-95 transition-all"
            >
              Hubungi Tim Kami
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="lg:col-span-6 min-w-0 grid grid-cols-1 md:grid-cols-2 gap-4">
            {benefits.map((b, i) => (
              <div
                key={i}
                data-testid={`partnership-benefit-${i}`}
                className="min-w-0 p-5 rounded-2xl border border-white/15 bg-white/[0.03] hover:bg-white/10 hover:border-white/40 transition-all card-lift"
              >
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#e60012] to-[#ff6873] flex items-center justify-center mb-4">
                  <b.icon className="w-5 h-5 text-white" />
                </div>
                <h4 className="font-display text-base font-medium">{b.title}</h4>
                <p className="mt-2 text-xs text-white/60 leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
